export default "__VITE_ASSET__BGywUxTz__"